import { IHeaderMapping } from "../CreateAudienceRightPanel.types";

export const transformDataWithMappings = (
  data: Record<string, any>[],
  mappings: IHeaderMapping[]
) => {
  const activeMappings = mappings.filter(
    (m) => m.isMapped && m.selectedMapping
  );

  const mappedHeaders = activeMappings.map((m) => m.selectedMapping);

  const transformedData = data.map((row) => {
    const newRow: Record<string, any> = {};

    activeMappings.forEach((mapping) => {
      newRow[mapping.selectedMapping] = row[mapping.header];
    });

    return newRow;
  });

  return {
    headers: mappedHeaders,
    data: transformedData,
  };
};
